import {post,get, nPost} from '@/libs/ajax.js'
 /**
 * 获取任务配置项
 * @param {*} data
 * @returns
 */
export function getAdjustmentConfigApi() {
    return get('/ad_batch_adjustment/get_config')
}
/**
 * 获取筛选内容
 * @returns 
 */
export function getAdjustmentConditionListApi(data) {
    return post('/ad_batch_adjustment/get_condition', data)
}
/**
 * 保存任务
 * @param {*} data 
 * @returns 
 */
export function saveAdjustmentDataApi(data) {
    return post('/ad_batch_adjustment/save', data)
}
/**
 * 复制任务保存
 * @param {*} data 
 * @returns 
 */
export function saveCopyAdjustmentDataApi(data) {
    return post('/ad_batch_adjustment/copy_save', data)
}
/**
 * 前置保存任务
 * @param {*} data 
 * @returns 
 */
export function preSaveAdjustmentDataApi(data) {
    return post('/ad_batch_adjustment/save_pre_check', data)
}
/**
 * 前置复制任务保存
 * @param {*} data 
 * @returns 
 */
export function preSaveCopyAdjustmentDataApi(data) {
    return post('/ad_batch_adjustment/copy_save_pre_check', data)
}
/**
 * 复制任务
 * @param {*} data 
 * @returns 
 */
export function copyAdjustmentDataApi(data) {
    return get('/ad_batch_adjustment/copy_task', data)
}
export default {
    // 列表页下拉数据
    postListSelectApi(data,options) {
        return nPost('/ad_batch_adjustment/get_search_list', data, options)
    },
    // 列表页列表
    postListApi(data,options) {
        return post('/ad_batch_adjustment/get_list', data, options)
    },
    //列表页 刷新单条
    getListStatusApi(data,options) {
        return get('/ad_batch_adjustment/get_task_status', data, options)
    },

    //列表页 复制
    getCopyApi(data,options) {
        return get('/ad_batch_adjustment/copy_task', data, options)
    },

    //列表页 详情 ？
    getDetailApi(data,options) {
        return get('/ad_batch_adjustment/get_task', data, options)
    },

    //列表页 重试
    postReApi(data,options) {
        return post('/ad_batch_adjustment/retry', data, options)
    },

    // 详情页下拉数据
    postInfoSelectApi(data,options) {
        return post('/ad_batch_adjustment/detail/get_search_list', data, options)
    },

    // 详情页列表
    postInfoListApi(data,options) {
        return post('/ad_batch_adjustment/detail/get_list', data, options)
    },
    //  终止
    postStopTaskApi(data,options) {
        return post('/ad_batch_adjustment/stop_task', data, options)
    },
}



